import React from "react";
import "./ColorJarLogo.css";

const ColorJarLogo: React.FC = () => {
  return (
    <div className="colorjar-logo">
      <svg viewBox="0 0 80 80" className="logo-svg">
        <defs>
          <linearGradient id="liquidGrad" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#ff6b6b">
              <animate
                attributeName="stop-color"
                values="#ff6b6b;#feca57;#48dbfb;#ff9ff3;#ff6b6b"
                dur="4s"
                repeatCount="indefinite"
              />
            </stop>
            <stop offset="50%" stopColor="#feca57">
              <animate
                attributeName="stop-color"
                values="#feca57;#48dbfb;#ff9ff3;#ff6b6b;#feca57"
                dur="4s"
                repeatCount="indefinite"
              />
            </stop>
            <stop offset="100%" stopColor="#48dbfb">
              <animate
                attributeName="stop-color"
                values="#48dbfb;#ff9ff3;#ff6b6b;#feca57;#48dbfb"
                dur="4s"
                repeatCount="indefinite"
              />
            </stop>
          </linearGradient>
          <clipPath id="jarClipLogo">
            <path d="M20 28C20 25 23 22 27 22H53C57 22 60 25 60 28V60C60 66 55 70 45 70H35C25 70 20 66 20 60V28Z" />
          </clipPath>
          <filter id="glow">
            <feGaussianBlur stdDeviation="2" result="coloredBlur" />
            <feMerge>
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        {/* Jar body */}
        <path
          d="M20 28C20 25 23 22 27 22H53C57 22 60 25 60 28V60C60 66 55 70 45 70H35C25 70 20 66 20 60V28Z"
          fill="rgba(255,255,255,0.2)"
          stroke="rgba(255,255,255,0.8)"
          strokeWidth="2"
          className="jar-body"
        />

        {/* Jar lid */}
        <rect
          x="24"
          y="12"
          width="32"
          height="10"
          rx="3"
          fill="rgba(255,255,255,0.9)"
          className="jar-lid"
        />
        <rect
          x="26"
          y="14"
          width="28"
          height="3"
          rx="1.5"
          fill="rgba(255,255,255,0.5)"
        />

        {/* Colorful liquid inside */}
        <g clipPath="url(#jarClipLogo)">
          {/* Wavy liquid surface */}
          <path
            className="liquid-wave wave-1"
            d="M15 38C22 34 28 42 35 38C42 34 48 42 55 38C62 34 68 42 75 38V75H15V38Z"
            fill="url(#liquidGrad)"
          />
          <path
            className="liquid-wave wave-2"
            d="M15 42C22 38 28 46 35 42C42 38 48 46 55 42C62 38 68 46 75 42V75H15V42Z"
            fill="url(#liquidGrad)"
            opacity="0.7"
          />

          {/* Floating color blobs */}
          <circle
            className="blob blob-1"
            cx="30"
            cy="52"
            r="6"
            fill="#ff6b6b"
            opacity="0.9"
            filter="url(#glow)"
          />
          <circle
            className="blob blob-2"
            cx="45"
            cy="48"
            r="5"
            fill="#48dbfb"
            opacity="0.9"
            filter="url(#glow)"
          />
          <circle
            className="blob blob-3"
            cx="52"
            cy="58"
            r="4"
            fill="#feca57"
            opacity="0.9"
            filter="url(#glow)"
          />
          <circle
            className="blob blob-4"
            cx="35"
            cy="62"
            r="4.5"
            fill="#ff9ff3"
            opacity="0.9"
            filter="url(#glow)"
          />
          <circle
            className="blob blob-5"
            cx="48"
            cy="64"
            r="3"
            fill="#a78bfa"
            opacity="0.9"
            filter="url(#glow)"
          />
        </g>

        {/* Glass shine effect */}
        <path
          d="M24 28V50"
          stroke="rgba(255,255,255,0.4)"
          strokeWidth="2"
          strokeLinecap="round"
          className="glass-shine"
        />
        <circle
          cx="28"
          cy="30"
          r="2"
          fill="rgba(255,255,255,0.5)"
          className="glass-highlight"
        />
      </svg>
    </div>
  );
};

export default ColorJarLogo;
